import type { PropType, ExtractPublicPropTypes } from 'vue'
import { apiProps } from '@el-plus/utils/props'
import type { TransferDataItem } from 'element-plus'

export const customColumnProps = {
  module: {
    type: [Number, String] as PropType<number | string>,
  },
  api: {
    ...apiProps.api,
    default: '/api-item/api/customizedColumns/find',
  },
  saveApi: {
    ...apiProps.api,
    default: '/api-item/api/customizedColumns/save',
  },
  showHandler: {
    type: Boolean,
    default: true,
  },
} as const
export type CustomColumnProps = ExtractPublicPropTypes<typeof customColumnProps>
export const customColumnEmits = {
  confirm: (data: TransferDataItem[]) => true,
  loaded: (data: TransferDataItem[]) => true,
}
export type CustomColumnEmits = typeof customColumnEmits
